<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-form ref="MPORSummary" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>Summary of Accomplishment ({{ monthRange }})</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-card>
              <v-row>
                <v-col cols="12" v-if="isSubmitted">
                  <v-stepper alt-labels class="elevation-0">
                    <v-stepper-header>
                      <v-stepper-step
                        step="1"
                        class="pa-5"
                        :complete="assessed_by_status == 2 ? true : false"
                        :rules="[() => assessed_by_status != 3]"
                        color="#6DB249"
                      >
                        <div style="width: 200px" class="text-center">
                          {{ assessed_by }}<br />
                          <small>Assessed By</small>
                        </div>
                      </v-stepper-step>
                    </v-stepper-header>
                  </v-stepper>
                </v-col>
                <v-col cols="8" class="flex-items mt-2">
                  <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                    <v-tab
                      v-for="tab in tabList"
                      :key="tab.id"
                      @click="changeTab(tab)"
                      >{{ tab.name }}</v-tab
                    >
                  </v-tabs>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="12" class="pt-2 px-4">
                  <v-data-table
                    :expanded.sync="expanded"
                    :headers="tab != 3 ? headers : headers1"
                    :items="dataItem"
                    :items-per-page="-1"
                    show-expand
                  >
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.suc_ind`]="{ item }"
                    >
                      {{ getItemSuccessIndicator(item) }}
                    </template>
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.efficiency`]="{ item }"
                    >
                      {{ item.eff_is_rated ? item.e_total : "Not to be Rated" }}
                    </template>
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.quality`]="{ item }"
                    >
                      {{
                        item.qly_is_rated
                          ? item.q_total + " | " + item.q_avg
                          : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.timeliness`]="{ item }"
                    >
                      {{
                        item.timeliness_is_rated
                          ? item.t_total + " | " + item.t_avg
                          : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.success_indicator`]="{ item }"
                    >
                      {{ item.success_indicator }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.supp_efficiency`]="{ item }"
                    >
                      {{
                        item.eff_is_rated ? item.efficiency : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.supp_quality`]="{ item }"
                    >
                      {{
                        item.qly_is_rated
                          ? item.quality
                            ? item.quality
                            : "" + " | " + item.q_avg
                            ? item.q_avg
                            : ""
                          : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.supp_timeliness`]="{ item }"
                    >
                      {{
                        item.timeliness_is_rated
                          ? item.timeliness
                            ? +item.timeliness
                            : "" + " | " + item.t_avg
                            ? item.t_avg
                            : ""
                          : "Not to be Rated"
                      }}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <table id="tbl_expanded">
                          <tr>
                            <th
                              class="text-caption font-weight-bold"
                              :colspan="e_span"
                              style="width: 33%"
                            >
                              Efficiency
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              :colspan="qt_span"
                              style="width: 33%"
                            >
                              Quality
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              :colspan="qt_span"
                              style="width: 33%"
                            >
                              Timeliness
                            </th>
                          </tr>
                          <tr>
                            <td
                              v-for="(ii, i) in expandHeaders"
                              :key="i"
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              {{ ii }}
                            </td>
                          </tr>

                          <tbody>
                            <tr v-if="tab != 3">
                              <td
                                v-for="(summary, i) in item.mporSummary"
                                :key="i"
                                :colspan="summary.colspan"
                                align="center"
                                class="text-caption"
                              >
                                {{ summary.value }}
                              </td>
                            </tr>

                            <tr v-if="tab == 3">
                              <td
                                v-for="(summary, i) in item.supportSummary"
                                :key="i"
                                :colspan="summary.colspan"
                                align="center"
                                class="text-caption"
                              >
                                {{ summary.value }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </template>
                    <template
                      v-slot:[`item.actions`]="{ item }"
                      v-if="toPending"
                    >
                      <v-btn
                        v-if="item.summary_pendingRemarks.length > 0"
                        x-small
                        block
                        class="my-1"
                        color="primary"
                        outlined
                        @click="viewItem(item)"
                      >
                        view remarks
                      </v-btn>
                      <v-btn
                        block
                        x-small
                        class="my-1"
                        color="red"
                        outlined
                        @click="pendingItem(item)"
                      >
                        add pending remarks
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="approval_type == 1" class="pa-5">
            <v-spacer></v-spacer>
            <!-- <v-btn color="red" class="white--text" @click="pending()">
              Pendings
            </v-btn> -->
            <v-btn
              color="red"
              v-if="!toPending"
              outlined
              @click="setToPending()"
            >
              pending
            </v-btn>
            <v-btn
              color="#519043"
              v-if="!toPending"
              class="white--text"
              @click="approve()"
            >
              Approve
            </v-btn>

            <v-btn
              color="red"
              :disabled="confirmLoading"
              v-if="toPending"
              outlined
              @click="cancelPending()"
            >
              Cancel Pending
            </v-btn>
            <v-btn
              v-if="toPending"
              color="#519043"
              class="white--text"
              :disabled="confirmLoading"
              :loading="confirmLoading"
              @click="confirmPending()"
            >
              Confirm Pending
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to <b>{{ approvalAction }}</b> this
              <b>IPCR Summary </b>?<br />
              <!-- Please note that
              <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelConfirm()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- remarks dialog -->
    <v-dialog v-model="addRemarksDialog" persistent max-width="600">
      <v-card color="white">
        <v-form ref="RemarksFormref" @submit.prevent>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span> </span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="addRemarksDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 400px" class="my-4"> </v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-h6">
                  {{
                    approvalAction == "APPROVE"
                      ? "Add Observation and Remarks"
                      : "Add Remarks"
                  }}
                </div>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="remarksMsg"
                  :rules="[formRules.required]"
                  dense
                  placeholder="Type here..."
                  outlined
                  rows="5"
                  required
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="addRemarksDialog = false">
              Close
            </v-btn>
            <v-btn
              v-if="approvalAction == 'APPROVE'"
              color="green"
              class="white--text"
              @click="saveApprovalRemarks()"
            >
              Save
            </v-btn>
            <v-btn
              v-if="approvalAction == 'PENDING'"
              color="green"
              class="white--text"
              @click="savePendingRemarks()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- <MPOROutputDialog :data="mporData" /> -->
    <RemarksDialog
      :data="itemToPending"
      v-on:saveRemarks="saveRemarks"
      v-on:closeRemarks="closeRemarks"
      :type="type"
      :moduleFrom="'IPCR SUMMARY APPROVAL'"
    />

    <ViewRemarksTimelineDialog
      :data="list"
      v-on:closeRemarksTimeline="closeRemarksTimeline"
    />
    <WarningDialog :msg="cancelMsg" v-on:yes="yes" v-on:no="no" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="fadeAwayMessage.timeout"
    ></fade-away-message-component>
  </div>
</template>

<script>
import RemarksDialog from "./RemarksDialog.vue";
import ViewRemarksTimelineDialog from "./ViewRemarksTimelineDialog.vue";
import WarningDialog from "./WarningDialog.vue";

export default {
  components: {
    RemarksDialog,
    ViewRemarksTimelineDialog,
    WarningDialog,
    // MPOROutputDialog: () => import("../Forms/MPOROutputDialog.vue"),
  },
  props: {
    data: null,
    approval_type: null,
  },
  data() {
    return {
      remarksData: [],
      approvalAction: null,
      remarksMsg: null,
      addRemarksDialog: false,
      ipcr_ID: null,
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      assesed_by_status: null,
      action: null,
      isloading: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
        timeout: 1500,
      },
      options: {},
      period: null,
      expanded: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      mporData: null,
      ipcr: null,
      expandHeaders: [],
      dataItem: [],
      monthsList: [],
      e_span: null,
      qt_span: null,
      monthSelection1: [
        {
          id: 1,
          name: "Jan",
        },
        {
          id: 2,
          name: "Feb",
        },
        {
          id: 3,
          name: "Mar",
        },
        {
          id: 4,
          name: "Apr",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "Jun",
        },
      ],
      monthSelection2: [
        {
          id: 7,
          name: "Jul",
        },
        {
          id: 8,
          name: "Aug",
        },
        {
          id: 9,
          name: "Sep",
        },
        {
          id: 10,
          name: "Oct",
        },
        {
          id: 11,
          name: "Nov",
        },
        {
          id: 12,
          name: "Dec",
        },
      ],
      monthSelection3: [
        {
          id: 1,
          name: "Jan",
        },
        {
          id: 2,
          name: "Feb",
        },
        {
          id: 3,
          name: "Mar",
        },
        {
          id: 4,
          name: "Apr",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "Jun",
        },
        {
          id: 7,
          name: "Jul",
        },
        {
          id: 8,
          name: "Aug",
        },
        {
          id: 9,
          name: "Sep",
        },
        {
          id: 10,
          name: "Oct",
        },
        {
          id: 11,
          name: "Nov",
        },
        {
          id: 12,
          name: "Dec",
        },
      ],
      monthRange: null,
      headers: [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        // {
        //   text: "Action",
        //   value: "action",
        //   align: "end",
        //   width: 100,
        //   valign: "center",
        //   sortable: false,
        // },
      ],
      headers1: [
        {
          text: "MFO",
          value: "type",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "success_indicator",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "supp_efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "supp_quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "supp_timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ],
      toPending: false,
      pendingList: [],
      type: null,
      list: [],
      confirmLoading: false,
      itemToPending: null,

      cancelMsg: null,
      submitAction: null,
    };
  },

  watch: {
    data: {
      handler(data) {
        // console.log("Data Summary", data);
        this.pendingList = [];
        this.toPending = false;
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.expandHeaders = [];
        this.tab = 1;
        this.ipcr_ID = data.ipcr_ID;
        this.loadMonthList(data.periodFrom, data.periodTo, data.year);

        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeMPOROutputDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeMPOROutputDialog");
  },
  methods: {
    loadMonthList(from, to, year) {
      let mnth = [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ];
      this.monthsList = [];
      this.selectedMonth = null;

      for (let i = from - 1; i < to; i++) {
        this.monthsList.push(mnth[i]);
      }
      this.monthRange =
        this.monthsList[0].name +
        " to " +
        this.monthsList[this.monthsList.length - 1].name +
        " " +
        year;
      this.e_span = this.monthsList.length + 1;
      this.qt_span = this.monthsList.length + 2;
      this.loadExpandHeaders();
      // this.selectedMonth = this.monthsList[0].id;
      // console.log(this.monthsList);
    },

    initialize() {
      this.loading = true;
      if (this.tab != 3) {
        if (this.ipcr_ID) {
          this.axiosCall(
            "/ipcr-target/getMyIPCRTargetMPORSummary/" +
              this.ipcr_ID +
              "/" +
              this.tab,
            "GET"
          ).then((res) => {
            if (res) {
              // console.log("MPOR", res.data);
              this.dataItem = res.data.data;
              this.isSubmitted = res.data.summary.isSubmitted;
              this.loading = false;
            }
          });
        }
      } else {
        if (this.ipcr_ID) {
          this.axiosCall(
            "/ipcr-target/getMyIPCRSupportSummary/" + this.ipcr_ID,
            "GET"
          ).then((res) => {
            if (res) {
              console.log("MPOR SUPPORT", res.data);
              this.dataItem = res.data.data;
              this.isSubmitted = res.data.summary.isSubmitted;
              this.loading = false;
            }
          });
        }
      }

      //load signatory
      this.axiosCall(
        "/ipcr/getIPCRApproverNames/" + this.ipcr_ID + "/SUMMARY",
        "GET"
      ).then((res) => {
        if (res) {
          // console.log("earas", res.data);
          this.assessed_by = this.toTitleCase(res.data.assessed_by_name);
          this.assessed_by_status = res.data.assesed_by_status;
          // this.final_rating_by = this.toTitleCase(
          //   res.data.final_rating_by_name
          // );
          // this.final_rating_by_status = res.data.final_rating_by_status;
        }
      });
    },

    confirmPending() {
      this.submitAction = "confirm pending";
      this.cancelMsg =
        "Are you sure you want to PENDING this? Please note that this action is irreversible.";
    },

    cancelPending() {
      this.submitAction = "cancel pending";
      if (this.pendingList.length > 0) {
        this.cancelMsg =
          "You have added pending remarks! Are you sure you want to CANCEL the Pending? Added remarks will not be saved.";
      } else {
        this.removePendingRemarks();
      }
    },

    approve() {
      this.approvalAction = "APPROVE";
      this.cancelMsg =
        "Are you sure you want to APPROVE this? Please note that this action is irreversible.";
      this.submitAction = "approve";
    },

    showApprovalRemarks() {
      this.addRemarksDialog = true;
    },

    // approve() {
    //   this.approvalAction = "APPROVE";
    //   this.confirmSubmitDialog = true;
    // },

    pending() {
      this.approvalAction = "PENDING";
      this.confirmSubmitDialog = true;
    },

    setHeaders() {
      let headers = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ];
      let headersWAction = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "actions",
          width: 200,
          align: "center",
          sortable: false,
        },
      ];
      let support_headers = [
        {
          text: "MFO",
          value: "type",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "success_indicator",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "supp_efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "supp_quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "supp_timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ];
      // let support_headers_WAction = [
      //   {
      //     text: "MFO",
      //     value: "type",
      //     align: "start",
      //     valign: "start",
      //     width: 200,
      //     sortable: false,
      //   },
      //   {
      //     text: "Success Indicators",
      //     value: "success_indicator",
      //     align: "center",
      //     valign: "center",
      //     width: 200,
      //     sortable: false,
      //   },
      //   {
      //     text: "E Total",
      //     value: "supp_efficiency",
      //     align: "center",
      //     valign: "center",
      //     sortable: false,
      //   },
      //   {
      //     text: "Q Total | Avg",
      //     value: "supp_quality",
      //     align: "center",
      //     valign: "center",
      //     sortable: false,
      //   },
      //   {
      //     text: "T Total | Avg",
      //     value: "supp_timeliness",
      //     align: "center",
      //     valign: "center",
      //     sortable: false,
      //   },
      //   {
      //     text: "Remarks",
      //     value: "remarks",
      //     align: "center",
      //     valign: "center",
      //     width: 200,
      //     sortable: false,
      //   },
      // ];

      this.headers = this.toPending ? headersWAction : headers;
      this.headers1 = support_headers;
      // ? support_headers_WAction
      // : support_headers;
    },
    setToPending() {
      this.toPending = true;
      this.setHeaders();
    },
    saveRemarks(data) {
      this.setHeaders();
      this.initialize();
      this.pendingList.push(data);
      console.log("calleded", this.pendingList);

      this.initialize();
    },
    closeRemarks(data) {
      this.itemToDelete = data;
    },
    closeRemarksTimeline() {
      this.list = [];
    },
    pendingItem(item) {
      this.type =
        this.tab == 1
          ? "Core Function"
          : this.tab == 2
          ? "Strategic Priority"
          : "";
      this.itemToPending = null;
      setTimeout(() => {
        this.itemToPending = item;
      }, 100);
      console.log("PENDING", item);
    },

    viewItem(item) {
      console.log(item.summary_pendingRemarks);

      this.list = [];
      setTimeout(() => {
        this.list = item.summary_pendingRemarks;
      }, 100);
    },

    yes() {
      if (this.submitAction == "cancel pending") {
        this.removePendingRemarks();
      }
      if (this.submitAction == "confirm pending") {
        this.submitForPending();
      }
      if (this.submitAction == "approve") {
        this.showApprovalRemarks();
      }
    },
    no() {
      this.submitAction = null;
      this.cancelMsg = null;
    },

    submitForPending() {
      this.confirmLoading = true;
      let data = {
        remarks: this.remarksMsg,
        ipcr_ID: this.ipcr_ID,
      };
      this.axiosCall("/ipcr/pendingSummary", "POST", data).then((res) => {
        if (res.data.status == 200) {
          this.cancelMsg = null;
          this.confirmLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else if (res.data.status == 400) {
          this.cancelMsg = null;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    removePendingRemarks() {
      let data = {
        list: JSON.stringify(this.pendingList),
      };
      this.axiosCall("/remarks/remove-pending-remarks", "POST", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.cancelMsg = null;
            this.toPending = false;
            this.pendingList = [];
            this.setHeaders();
            this.initialize();
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Pending Cancelled!";
            // this.closeD();
          } else if (res.data.status == 400) {
            this.cancelMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      );
    },

    changeMPOR() {
      this.initialize();
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },
    saveApprovalRemarks() {
      if (this.$refs.RemarksFormref.validate()) {
        this.confirmBtnLoading = true;
        // this.isSubmitLoading = true;
        let data = {
          remarks: this.remarksMsg,
          ipcr_ID: this.ipcr_ID,
        };
        this.axiosCall("/ipcr/approveSummary", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.cancelMsg = null;
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
    savePendingRemarks() {
      if (this.$refs.RemarksFormref.validate()) {
        this.confirmBtnLoading = true;
        // this.isSubmitLoading = true;
        let data = {
          remarks: this.remarksMsg,
          ipcr_ID: this.ipcr_ID,
        };
        this.axiosCall("/ipcr/pendingSummary", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
    confirmSubmit() {
      this.confirmSubmitDialog = false;
      this.addRemarksDialog = true;
    },

    loadExpandHeaders() {
      this.expandHeaders = [];
      if (this.tab != 3) {
        for (let i = 0; i < 3; i++) {
          this.e_span = this.monthsList.length + 1;
          this.qt_span = this.monthsList.length + 2;
          for (let j = 0; j < this.monthSelection1.length; j++) {
            this.expandHeaders.push(this.monthsList[j].name);
          }
          if (i == 0) {
            this.expandHeaders.push("Total");
          } else if (i > 0) {
            this.expandHeaders.push("Total");
            this.expandHeaders.push("AVE");
          }
        }
      } else {
        for (let i = 0; i < 3; i++) {
          this.e_span = 1;
          this.qt_span = 2;

          if (i == 0) {
            this.expandHeaders.push("Total");
          } else if (i > 0) {
            this.expandHeaders.push("Total");
            this.expandHeaders.push("AVE");
          }
        }
      }
    },

    getItemSuccessIndicator(item) {
      return item.efficiency_type == "percentage"
        ? item.efficiency +
            "%" +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness
        : item.efficiency +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness;
    },
    getTotal(field, item) {
      if (item) {
        let i = item.mpor;

        if (field == "E") {
          let total = 0;
          if (item.eff_is_rated) {
            total += i ? (i.e_w1 ? i.e_w1 : 0) : "";
            total += i ? (i.e_w1 ? i.e_w2 : 0) : "";
            total += i ? (i.e_w1 ? i.e_w3 : 0) : "";
            total += i ? (i.e_w1 ? i.e_w4 : 0) : "";
            return total;
          } else {
            return "Not to be Rated";
          }
        } else if (field == "Q") {
          let total = 0;
          if (item.qly_is_rated) {
            total += i ? (i.q_w1 ? i.q_w1 : 0) : "";
            total += i ? (i.q_w1 ? i.q_w2 : 0) : "";
            total += i ? (i.q_w1 ? i.q_w3 : 0) : "";
            total += i ? (i.q_w1 ? i.q_w4 : 0) : "";
            return total;
          } else {
            return "Not to be Rated";
          }
        } else if (field == "T") {
          let total = 0;
          if (item.timeliness_is_rated) {
            total += i ? (i.t_w1 ? i.t_w1 : 0) : "";
            total += i ? (i.t_w1 ? i.t_w2 : 0) : "";
            total += i ? (i.t_w1 ? i.t_w3 : 0) : "";
            total += i ? (i.t_w1 ? i.t_w4 : 0) : "";
            return total;
          } else {
            return "Not to be Rated";
          }
        }
      }
    },
    closeD() {
      if (this.pendingList.length > 0) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "warning";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have added pending remarks! Please click the CANCEL PENDING button to cancel the pending process.";
      } else {
        this.eventHub.$emit("closeIPCRSummaryDialog", false);
        this.confirmSubmitDialog = false;
        this.addRemarksDialog = false;
        this.dialog = false;
      }
    },

    update(item) {
      console.log(item);
      this.mporData = item;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.loadExpandHeaders();
      this.initialize();
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
